import Api from '@/services/Api'

export default {
  getConfig() {
    return Api().get('cutoff/config')
  },

  getOrders(country) {
    return Api().get('cutoff/orders', { params: { country } })
  }
}
